import { StateCreator } from 'zustand'

import { Workspace, User } from '../types'
import { UserWorkspace } from '../types/workspace'

interface UserState {
  workspace: Workspace | null
  user: User | null
}

interface UserActions {
  removeUserWorkspace: (userWorkspace: UserWorkspace) => void
  setWorkspace: (workspace: Workspace) => void
  setUser: (user: User) => void
  updateUserWorkspace: (userWorkspace: UserWorkspace) => void
}

export type UserSlice = UserState & UserActions

export const initialUserState: UserState = {
  workspace: null,
  user: null,
}

const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (set) => ({
  ...initialUserState,
  removeUserWorkspace: (userWorkspace: UserWorkspace) =>
    set((state) => ({
      user: state.user
        ? {
            ...state.user,
            workspaces: state.user.workspaces.filter(
              (workspace) => workspace.id !== userWorkspace.id,
            ),
          }
        : null,
    })),
  setWorkspace: (workspace) => set({ workspace }),
  setUser: (user) => set({ user }),
  updateUserWorkspace: (userWorkspace: UserWorkspace) =>
    set((state) => ({
      user: state.user
        ? {
            ...state.user,
            workspaces: state.user.workspaces.map((workspace) =>
              workspace.id === userWorkspace.id ? userWorkspace : workspace,
            ),
          }
        : null,
    })),
})

export default createUserSlice
